// Auto-generated: imports for all layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/content/layouts/accordeon_contact/accordeon_contact.js';
import '../../flex/content/layouts/accordion_cards/accordion_cards.js';
import '../../flex/content/layouts/afbeelding_accordeon/afbeelding_accordeon.js';
import '../../flex/content/layouts/afdelingen_tabs/afdelingen_tabs.js';
import '../../flex/content/layouts/arbeidsvoorwaarden/arbeidsvoorwaarden.js';
import '../../flex/content/layouts/content_afbeelding/content_afbeelding.js';
import '../../flex/content/layouts/content_afbeelding_tekst/content_afbeelding_tekst.js';
import '../../flex/content/layouts/content_afbeelding_voetnoot/content_afbeelding_voetnoot.js';
import '../../flex/content/layouts/content_list/content_list.js';
import '../../flex/content/layouts/content_media/content_media.js';
import '../../flex/content/layouts/content_media_narrow/content_media_narrow.js';
import '../../flex/content/layouts/content_media_wide/content_media_wide.js';
import '../../flex/content/layouts/content_switcher/content_switcher.js';
import '../../flex/content/layouts/content_video/content_video.js';
import '../../flex/content/layouts/faq/faq.js';
import '../../flex/content/layouts/faq_overview/faq_overview.js';
import '../../flex/content/layouts/hero_gallery/hero_gallery.js';
import '../../flex/content/layouts/hero_verhaal/hero_verhaal.js';
import '../../flex/content/layouts/image_accordion/image_accordion.js';
import '../../flex/content/layouts/intro_content/intro_content.js';
import '../../flex/content/layouts/keuzehulp/keuzehulp.js';
import '../../flex/content/layouts/location_map/location_map.js';
import '../../flex/content/layouts/procedure/procedure.js';
import '../../flex/content/layouts/sfeer_gallery/sfeer_gallery.js';
import '../../flex/content/layouts/statistics/statistics.js';
import '../../flex/content/layouts/uitklap_secties/uitklap_secties.js';
import '../../flex/content/layouts/vacature_content/vacature_content.js';
import '../../flex/content/layouts/vacature_filter/vacature_filter.js';
import '../../flex/content/layouts/vacature_slider/vacature_slider.js';
import '../../flex/content/layouts/verhalen_grid/verhalen_grid.js';
import '../../flex/content/layouts/verhalen_slider/verhalen_slider.js';
